// @ts-check
/** A suspended memory bank accepts the final jump and routes its bandwidth into the uplink.
 * @param {CanvasRenderingContext2D} c @param {import('../game/types.js').Level} level @param {import('./terrain.js').Palette} p @param {boolean} reduced
 */
export function paintBandwidthCore(c, level, p, reduced) {
  const x = level.finish, captured = level.signalHeight !== null;
  const selected = Math.floor((level.signalHeight ?? 0) / 80);
  const t = reduced ? 0 : level.time;
  c.save();
  // Five independent cartridge sockets, with etched traces leading into the exit.
  // Their open gaps and broad circuit housings read as hardware suspended in cyberspace.
  for (let tier = 0; tier < 5; tier++) {
    const y = -tier * 80 - 18, active = captured && tier === selected;
    const color = active ? p.gold : captured ? p.edge : tier === 4 ? p.violet : p.cyan;
    const w = 62 + tier * 3;
    c.globalAlpha = captured && !active ? .42 : 1;
    c.strokeStyle = color; c.lineWidth = 1.2;
    c.beginPath(); c.moveTo(x + w / 2, y); c.lineTo(x + 48, y); c.lineTo(x + 58, y + 10); c.lineTo(x + 58, -10); c.lineTo(x + 260, -10); c.stroke();
    c.fillStyle = p.panel; c.strokeStyle = p.steel;
    c.beginPath(); c.moveTo(x - w / 2 + 6, y - 20); c.lineTo(x + w / 2 - 6, y - 20); c.lineTo(x + w / 2, y - 14); c.lineTo(x + w / 2, y + 14); c.lineTo(x + w / 2 - 6, y + 20); c.lineTo(x - w / 2 + 6, y + 20); c.lineTo(x - w / 2, y + 14); c.lineTo(x - w / 2, y - 14); c.closePath(); c.fill(); c.stroke();
    c.fillStyle = p.void; c.fillRect(x - w / 2 + 5, y - 14, w - 10, 28);
    c.strokeStyle = color; c.strokeRect(x - 15, y - 11, 30, 22);
    c.shadowColor = color; c.shadowBlur = reduced ? 0 : active ? 14 : 3;
    c.fillStyle = color;
    for (let pin = 0; pin < 4; pin++) {
      c.fillRect(x - 12 + pin * 7, y - 14, 3, 3); c.fillRect(x - 12 + pin * 7, y + 11, 3, 3);
    }
    c.shadowBlur = 0; c.font = 'bold 9px monospace'; c.textAlign = 'center';
    c.fillText(active ? 'SYNC' : `${(tier + 1) * 500}`, x, y + 3);
    for (let bit = 0; bit < tier + 1; bit++) {
      c.globalAlpha = active || reduced ? 1 : .3 + .7 * ((t * .6 + bit * .2) % 1);
      c.fillRect(x - w / 2 + 7, y - 10 + bit * 4, 4, 2);
    }
    if (active) {
      c.globalAlpha = .65; c.strokeStyle = p.gold; c.lineWidth = 1;
      c.strokeRect(x - w / 2 - 5, y - 25, w + 10, 50);
      for (let bit = 0; bit < 6; bit++) {
        const travel = reduced ? bit / 6 : (t * .9 + bit / 6) % 1;
        c.fillRect(x + w / 2 + travel * 45, y + travel * (-10 - y), 3, 3);
      }
    }
  }
  c.globalAlpha = 1; c.fillStyle = p.light; c.font = 'bold 9px monospace'; c.textAlign = 'right';
  c.fillText(captured ? 'UPLOAD VERIFIED' : 'BANDWIDTH CORE', x - 51, -218);
  c.fillStyle = p.cyan; c.font = '8px monospace';
  c.fillText(captured ? `+${(selected + 1) * 500} BANDWIDTH BONUS` : 'JUMP · CONNECT · UPLOAD', x - 51, -204);
  c.restore();
}


/** Explore-style doorways reveal the destination without exposing pipe entrances.
 * @param {CanvasRenderingContext2D} c @param {import('../game/types.js').Level} level
 * @param {import('./terrain.js').Palette} p @param {boolean} reduced
 */
export function paintSecretDoors(c, level, p, reduced) {
  for (const door of level.definition.portals ?? []) {
    if (door.kind === 'pipe' || level.signals[`visited:${door.id}`] || door.reveal && !level.solids.find(s => s.id === door.reveal)?.used) continue;
    const x = door.x + door.width / 2, y = -door.y;
    c.save(); c.translate(x, y); c.fillStyle = p.void; c.strokeStyle = p.cyan; c.lineWidth = 2;
    c.beginPath(); c.moveTo(-20, 0); c.lineTo(-20, -54); c.quadraticCurveTo(-20, -70, 0, -70); c.quadraticCurveTo(20, -70, 20, -54); c.lineTo(20, 0); c.closePath(); c.fill(); c.stroke();
    c.globalAlpha = .35; c.fillStyle = p.violet; c.fillRect(-15, -52, 30, 52);
    c.strokeStyle = p.cyan; c.lineWidth = 1;
    for (let n = 0; n < 5; n++) {
      const y = -5 - (n * 11 + (reduced ? 0 : level.time * 14)) % 52;
      c.beginPath(); c.moveTo(-13, y); c.lineTo(13, y); c.stroke();
    }
    c.globalAlpha = 1; c.fillStyle = p.light; c.fillRect(12, -32, 3, 4); c.restore();
  }
}
